import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import { useCategories } from "../../categorys/locking/index";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import { useTotalCommission } from "../../hooks/useTotalCommission";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import ColumnFilterRow from "../../components/table/columnFilterRow";

const TableLocking = ({ setParamExport }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [projectId, setProjectId] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [status, setStatus] = useState([]);
  const [apartmentId, setApartmentId] = useState([]);
  // Lọc theo Tháng đối chiếu (StepCommission) — dùng DatePicker showMonthYearPicker
  // như màn "Xuất chi tiết phí dịch vụ". Tách ra month/year để gửi API.
  const [reconciliationMonthDate, setReconciliationMonthDate] = useState(null);
  const month = reconciliationMonthDate
    ? reconciliationMonthDate.getMonth() + 1
    : null;
  const year = reconciliationMonthDate
    ? reconciliationMonthDate.getFullYear()
    : null;

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    lockingManagementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
    // } = useTotalCommission(debouncedSearchTerm, projectId, status, apartmentId);
  } = useTotalCommission(
    debouncedSearchTerm,
    projectId,
    status,
    apartmentId,
    month,
    year,
  );

  useEffect(() => {
    setParamExport({
      search: debouncedSearchTerm,
      projectId,
      status,
      apartmentId,
      month,
      year,
    });
  }, [
    setParamExport,
    debouncedSearchTerm,
    projectId,
    status,
    apartmentId,
    month,
    year,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(null, null, 1, shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project],
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments],
  );

  const statusDatas = [
    {
      key: "UNPAID",
      value: "Chưa thanh toán",
    },
    {
      key: "PARTIAL",
      value: "Đang thanh toán",
    },
    {
      key: "PAID",
      value: "Đã thanh toán",
    },
  ];

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Mã căn",
        key: "codeApartment",
      },
      {
        label: "Tên dự án",
        key: "nameProject",
      },
      // {
      //   label: "Đợt đối chiếu",
      //   key: "period",
      // },
      {
        label: "Trạng thái",
        key: "paymentStatus",
      },
      {
        label: "Tổng PDV sau thuế",
        key: "totalRemainingRevenueAfterTax",
      },
      {
        label: "Tổng PDV đã TT",
        key: "totalAllCommissionPrice",
      },
      {
        label: "PDV còn lại",
        key: "totalRemainingCommission",
      },
    ],
    data: lockingManagementData,
  };

  // table
  const handleNavigate = (e) => {
    navigate(`/step-commission/disbursement?lockingId=${e?.lockingId}`);
  };

  // Giữ lựa chọn multi-select khi bảng remount trong Skeleton lúc refetch
  const selectedStatusOptions = useMemo(
    () => statusDatas.filter((o) => (status || []).includes(o.key)),
    [status],
  );
  const selectedApartmentOptions = useMemo(
    () => apartments.filter((o) => (apartmentId || []).includes(o.key)),
    [apartments, apartmentId],
  );
  const selectedProjectOptions = useMemo(
    () => projects.filter((o) => (projectId || []).includes(o.key)),
    [projects, projectId],
  );

  // Bộ lọc hiển thị ngay dưới tiêu đề cột — tái sử dụng state/setter sẵn có
  const columnFilters = {
    paymentStatus: (
      <SearchableSelectMulti
        isShowSearch={false}
        options={statusDatas}
        initialSelectedOption={selectedStatusOptions}
        placeholder={"Tất cả"}
        setValue={setStatus}
        width="100%"
        minW="180px"
      />
    ),
    codeApartment: (
      <SearchableSelectMulti
        isShowSearch={true}
        options={apartments}
        initialSelectedOption={selectedApartmentOptions}
        placeholder={"Tất cả"}
        setValue={setApartmentId}
        width="100%"
        minW="150px"
      />
    ),
    nameProject: (
      <SearchableSelectMulti
        isShowSearch={true}
        options={projects}
        initialSelectedOption={selectedProjectOptions}
        placeholder={"Tất cả"}
        setValue={setProjectId}
        width="100%"
        minW="150px"
      />
    ),
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"center"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              p={"16px 0px 12px 16px"}
              flexWrap={"wrap"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Tên sản phẩm, dự án "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <InputGroup w={"100%"} maxW={"200px"} zIndex={3}>
                <DatePicker
                  selected={reconciliationMonthDate}
                  onChange={(date) => setReconciliationMonthDate(date)}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  locale="vi"
                  isClearable={true}
                  placeholderText="Tháng đối chiếu"
                  className="datePickerStyle"
                  popperProps={{ strategy: "fixed" }}
                  portalId="datepicker-portal"
                />
                {!reconciliationMonthDate && (
                  <InputRightElement pointerEvents="none" h={"44px"}>
                    <Image src={calendarIcon} />
                  </InputRightElement>
                )}
              </InputGroup>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            {/* Header + hàng bộ lọc luôn hiển thị; chỉ hiện Skeleton ở vùng dữ liệu khi tải/refetch */}
            <>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "start";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "start";
                        } else if (e.key === "period") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "paymentStatus") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "totalAllCommissionPrice") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "totalRemainingRevenueAfterTax") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "totalRemainingRevenueAfterTax") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "totalRemainingCommission") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "10%";
                          textAlign = "start";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                    <ColumnFilterRow
                      headers={tableData.headers}
                      filters={columnFilters}
                      backgroundColor="#F9FAFD"
                    />
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {isLoading || isRefetching ? (
                      <Tr>
                        <Td colSpan={tableData.headers.length} p={"16px"}>
                          <Skeleton height="400px" borderRadius="8px" />
                        </Td>
                      </Tr>
                    ) : tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.lockingId;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handleNavigate(e)}
                                  >
                                    <Image src={iconDetail} /> Thanh toán
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "start";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "start";
                              } else if (keyvalue === "period") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "paymentStatus") {
                                width = "5%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "totalAllCommissionPrice"
                              ) {
                                width = "15%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "totalRemainingRevenueAfterTax"
                              ) {
                                width = "15%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "totalRemainingCommission"
                              ) {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "codeApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "start";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default TableLocking;
